export enum AppPlatformType {
  Mobile = 'mobile',
  Web = 'web',
  Desktop = 'desktop',
}
